import React, { useState } from 'react';
import Menu from '../../../../components/Menu';
import SVGIcon from '../../../../components/SVGIcon';
import overflowMenuIcon from '../../../../icons/overflowMenu.svg';
import ToolbarButton from './ToolbarButton';

interface ToolbarOverflowMenuButtonProps {
  children(onClose: () => void): React.ReactNode;
  onMenuOpenChange?: (open: boolean) => void;
  testId?: string;
  rightAlignPopOver?: boolean;
}

const ToolbarOverflowMenuButton = ({
  children,
  onMenuOpenChange,
  testId,
  rightAlignPopOver,
}: ToolbarOverflowMenuButtonProps) => {
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);

  return (
    <ToolbarButton
      popOverHideCaret
      rightAlignPopOver={rightAlignPopOver}
      icon={<SVGIcon coloringWith="fill">{overflowMenuIcon}</SVGIcon>}
      // eslint-disable-next-line react/no-unstable-nested-components -- Fix next time editing the file
      popOver={(onClose) => <Menu>{children(onClose)}</Menu>}
      popOverOpen={isPopOverOpen}
      onPopOverOpenChange={(open) => {
        setIsPopOverOpen(open);
        onMenuOpenChange?.(open);
      }}
      testId={testId}
      aria-label="More options"
    />
  );
};

export default ToolbarOverflowMenuButton;
